export default {
    api: process.env.NODE_ENV == "production" ? "https://api.therres.adnera.de" : "https://localhost:7060"
    // api: process.env.NODE_ENV == "production" ? "https://api.rosenhagen.adnera.de" : "https://localhost:7060"
    // api: process.env.NODE_ENV == "production" ? "http://hq-terrassendach.ip-register.info:7071" : "https://localhost:7060"
    //api: process.env.NODE_ENV == "production" ? "http://api.rosenhagen-metallbau.de" : "https://localhost:7060"
    // api: process.env.NODE_ENV == "production" ? "https://api.therres.adnera.de" : "https://localhost:7060"
};